/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangeContactDetailsRequestBody
 */
export interface ChangeContactDetailsRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ChangeContactDetailsRequestBody
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeContactDetailsRequestBody
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeContactDetailsRequestBody
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeContactDetailsRequestBody
     */
    mobileNumber: string;
}

/**
 * Check if a given object implements the ChangeContactDetailsRequestBody interface.
 */
export function instanceOfChangeContactDetailsRequestBody(value: object): value is ChangeContactDetailsRequestBody {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('mobileNumber' in value) || value['mobileNumber'] === undefined) return false;
    return true;
}

export function ChangeContactDetailsRequestBodyFromJSON(json: any): ChangeContactDetailsRequestBody {
    return ChangeContactDetailsRequestBodyFromJSONTyped(json, false);
}

export function ChangeContactDetailsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeContactDetailsRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'phoneNumber': json['phoneNumber'],
        'mobileNumber': json['mobileNumber'],
    };
}

export function ChangeContactDetailsRequestBodyToJSON(json: any): ChangeContactDetailsRequestBody {
    return ChangeContactDetailsRequestBodyToJSONTyped(json, false);
}

export function ChangeContactDetailsRequestBodyToJSONTyped(value?: ChangeContactDetailsRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'phoneNumber': value['phoneNumber'],
        'mobileNumber': value['mobileNumber'],
    };
}

